import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from 'src/app/___LOGIC/___common/__config/config.service';
import { AuthService } from 'src/app/___LOGIC/__auth/auth.service';
import { CalendlyService } from 'src/app/___LOGIC/__calendly/calendly.service';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { DataProviderService } from 'src/app/___LOGIC/__data/data-provider.service';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';
import { NavigationService } from 'src/app/___LOGIC/__navigation/navigation.service';
import { OrdersService } from 'src/app/___LOGIC/__orders/orders.service';
import { ShopifyService } from 'src/app/___LOGIC/__shopify/shopify.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  debug = environment.debugMode;
  
  subApps: any[] = [];
  @ViewChild('videocall60') step10: ElementRef;

/*   Conoce los detalles de nuestra colaboración con Omnibus
  <div class="post-image"><img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/ac4fa934-80ef-4090-8b69-78c82c96c900/userApp" alt=""></div> */

/*   <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/119a29b2-8123-4e02-2def-e57410257000/public" alt="">
          <div class="card-image-footer">
            <div class="card-category bg-color-white">Science</div>
            <h2>ETIAS – Sistema Europeo de Información y Autorización de Viajes</h2>
          </div> */

  additionalServicesOld = [
    {
      title: 'Asistencia Legal',
      description: 'Obtén ayuda legal profesional',
      icon: 'gavel',
      route: '/sub-app/legal-helper'
    },
    { 
      title: 'Búsqueda de apartamento',
      description: 'Te acompañamos a tus citas importantes',
      icon: 'home',
      route: '/sub-app/accommodation-helper'
    },
    { 
      title: 'Elegir el máster adecuado',
      description: 'Te ayudamos a elegir el mejor curso.',
      icon: 'book' ,
      route: '/sub-app/visa-helper'
    },
    { 
      title: 'Obtener visado de estudios',
      description: 'Revisión y dudas sobre el proceso de visado de estudios',
      icon: 'account_box' ,
      route: '/sub-app/visa-helper'
    },
    { 
      title: 'Primeros días en España',
      description: 'Consejos para tus primeros meses en Europa',
      icon: 'person_pin_circle' ,
      route: '/sub-app/visa-helper'
    }
  ];

  blogArticles = {
    cardId: 'A',
    title: 'Últimos artículos del blog',
    subtitle: '',
    imageUrl: '../../assets/images/components/mobile/image1.png',
    longPar: '',
    longParLimit: '',
    shortPara: '',
    allVisible: false,
    fieldForTitle:'title',
    fieldForContent: 'description',
    array: [
        { id: '1', 
          title: 'Servicios legales Bach Legal',
          description: 'Conoce los detalles de nuestra colaboración con Bach Legal',
          imageUrl: this.guiFlow.getImage('facdb2a5-4e8b-4378-6e52-0d0999a73700','icon'),
          snippet: 'Servicios Legales.' 
        },
        { id: '2',
          title: 'Seguro médico de la mano de Omnibus',
          imageUrl: this.guiFlow.getImage('0539da1d-067c-4845-c711-9db70b7e9500','icon'),
          description: 'Conoce los detalles de nuestra colaboración con Omnibus',
          snippet: 'Seguros - Salud' }
    
        /* { title: 'How to Save Money While Studying Abroad', snippet: 'Tips and tricks on managing your finances as a student.' },
        { title: 'Top 10 Cities for Expats in Europe', snippet: 'Discover the best cities in Europe for expatriates.' } */
      ]
  };


  legalService = {
    title: 'Asistencia Legal',
    description: 'Obtén ayuda legal profesional',
    icon: 'gavel'
  };

  arrayResult = [
    {
      title: '¿Quieres vivir en Europa pero no sabés por dónde comenzar?',
      subtitle: 'Llevas años con el deseo de vivir en Europa ya sea para estudiar o trabajar.',
      badgeText: 'VoyJaleas para Europa!',
      text: 'Si nosotros lo conseguimos, vos también podés!',
      /* Photo by <a href="https://unsplash.com/@joshuaearle?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Joshua Earle</a> on <a href="https://unsplash.com/photos/man-standing-in-bridge-j-PDxMrVyw4?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> */
      imageUrl: this.guiFlow.getImage('29881e66-3cb2-4262-9c76-f7ceb8c08500','public'), 
    },
    /* Photo by <a href="https://unsplash.com/@napr0tiv?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Vasily Koloda</a> on <a href="https://unsplash.com/photos/group-of-fresh-graduates-students-throwing-their-academic-hat-in-the-air-8CqDvPuo_kI?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> */
    {
      title: '',
      subtitle: 'Estudiar un máster, un curso, idioma, trabajar, turismo...',
      badgeText: 'Encontrar máster adecuado para mí',
      text: 'Te ayudaremos a encontrar el programa de curso que mejor se adapte a tus necesidades.',
      imageUrl: this.guiFlow.getImage('8d162c97-63b7-48ff-149e-f24f1b091c00','public'), 
    },
    {
      title: '',
      subtitle: 'Tienes dudas con tus procesos legales o e extranjería',
      badgeText: 'Bach Legal',
      text: 'Tenemos un equipo de abogados en España que te puede ayudar.',
      imageUrl: this.guiFlow.getWorkerImage('servicios-legal-2.png','public'), 
    }
  ];

  algunosMomentos = [
    { city: 'Parque Güell', date:'24/03/2012', id: 'parqueGuell', link: '', imageUrl: 'https://voyjaleas-website.sebtec12.workers.dev/SEBAS_parkGuell_24_03_2012.JPG' },
    { city: 'Montserrat con Ale', id: 'mapaMetroMadrid', link: '',imageUrl: 'https://voyjaleas-website.sebtec12.workers.dev/SEBAS_montserratConAle.png' },
    { city: 'Viendo a Nadal en vivo', date: '10/5/2013', id: 'mapaMetroMadrid', link: '',imageUrl: 'https://voyjaleas-website.sebtec12.workers.dev/SEBAS_cajaMagica_10_05_2013.JPG' },
    { city: 'Sierra de Madrid',id: 'mapaMetroBarcelona', link: '', imageUrl: 'https://voyjaleas-website.sebtec12.workers.dev/SEBAS_sierraDeMadrid.png' },
    { city: 'Madrid, mi ciudad!',date: '28/2/2022',id: 'mapaMetroBarcelona', link: '', imageUrl: 'https://voyjaleas-website.sebtec12.workers.dev/SEBAS_granVia_28_2_2022.png' },
  ]

  quieroComenzar = {
    title: 'Quiero comenzar con mi proceso',
    badgeText: 'Primeros pasos',
    /* Photo by <a href="https://unsplash.com/@charlesdeluvio?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">charlesdeluvio</a> on <a href="https://unsplash.com/photos/man-using-macbook-Lks7vei-eAg?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> */
    imageUrl: this.guiFlow.getImage('f3cc98c7-f799-47cd-628e-05c9da3fb900','public')
  }

  public isLoggedIn = false;
  
  notifications =[] ;
  status = '';
  /* notifications: NotificationBubble[] = []; */

  constructor(private router: Router,private calendlyService: CalendlyService, private dataProvider: DataProviderService,private guiFlow: GuiFlowService,private commonFunctions: FunctionsService,private authService: AuthService,private navigationService: NavigationService,private ordersService: OrdersService,private shopifyService: ShopifyService,private route: ActivatedRoute,private configService: ConfigService) {
    this.isLoggedIn = this.authService.isUserLoggedIn;

    if(!this.isLoggedIn){
      this.dataProvider.createMocks('getThisClientApps');
    }

    // Subscribe to login state changes
    this.authService.isUserLoggedIn$().subscribe((status) => {
      this.isLoggedIn = status;
      //this.updateNavigation();
    });
  }
  //private userService: UserService, 
  ngOnInit() {
    /* this.notificationService.notifications$.subscribe(notifications => {
      this.notifications = notifications.filter(notification => notification.dismissed);
    }); */

    // Fetch sub-apps data from service if needed
    // this.userService.getAvailableSubApps().subscribe(data => {
    //   this.subApps = data;
    // });
  }

    ngAfterViewInit() {
    // Map fragments to ViewChild elements
    const sectionMap: { [key: string]: ElementRef<HTMLDivElement> } = {
      videocall60: this.step10
    };

    // Call the shared service to handle scrolling
    this.navigationService.scrollToFragment(this.route, sectionMap);
  }

  getVisibleSections(){
    return this.dataProvider.getVisibleApps();
  }

  openArticle(article){
    this.router.navigateByUrl('/article-details/'+article.id);
  }

  goToArticle(id){
    this.router.navigateByUrl('article/'+id);
  }

  hireService(service: any) {
    // Logic to hire the service sub-app/legal-helper
    this.router.navigateByUrl(service.route);
  }

  triggerNotification() {
    /* this.notificationService.addNotification('This is a new notification!'); */
  }

  handleCta(eventObj: any) {
    this.navigationService.goToViewSection(eventObj.linkUrl,eventObj.section);
  }

  bookVideocall(product){
    let link = 'https://calendly.com/voy-jaleas/voy-jaleas-consultoria';
    //
    window.open(link, '_blank');
  }
  
  isStatus(status){
    return this.status == status;
  }

  buyProduct(myVariantLabel){
    this.status = 'processing';
    debugger
    this.ordersService.buyProduct(myVariantLabel).subscribe({
      next: (response) => {
        if (response && response.OK) {
          debugger
          let orderObject = {
            'productVariantId': this.configService.findVariantBy(this.configService.getStockProductsFromShopify(),'variantLabel', myVariantLabel).variantId
          };
          response.OK.records.FK_ID_clientDetails? orderObject['user_id'] = response.OK.records.FK_ID_clientDetails : null; // In case user is logged in
          this.shopifyService.buyProduct(orderObject);
          this.checkIsOrderProcessed(response.OK.records.orderCode);
        } else {
          console.warn('Order creation failed:', response);
          // Handle case where API returns success: false
        }
      },
      error: (error) => {
        this.guiFlow.openSimpleSnackBar('Error, intentalo de nuevo','error',null,'');
        console.error('HTTP request failed:', error);
        if (error.status === 0) {
          console.error('Likely CORS error or Network issue');
        } else {
          console.error(`Error ${error.status}: ${error.message}`);
        }
      }
    })
  }

  buyProductSimple(myVariantLabel){
    let orderObject = {
            'productVariantId': this.configService.findVariantBy(this.configService.getStockProductsFromShopify(),'variantLabel', myVariantLabel).variantId
    };
    this.shopifyService.buyProduct(orderObject);
  }

  checkIsOrderProcessed(orderId){
    //this.showSpinnerModal('Procesando orden');
    this.ordersService.checkIsOrderProcessed(orderId).subscribe({
      next: (result) => {
        if (result && result.status === 'paid') {
          //this.lastOrderCode = result.orderData.orderCode;
          this.status = 'paid';
          if (result.orderData.FK_ID_clientDetails) {
            //this.showPaymentReceivedModal();
          } else {
            console.log('Error, no client associated to this purchase');
          }
        }
      },
      error: (err) => {
        console.error('Payment failed or timed out:', err);
      }
    });
  }

}
